import { useEffect, useState } from 'react';

/**
 * Hook to get window size and height on resize
 * @returns {object{isMobile: boolean, width: number, height: number}} size
 */

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({});
  useEffect(() => {
    updateSize();
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize');
  }, []);

  const updateSize = () => {
    setWindowSize({
      isMobile: window?.innerWidth < 768,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
  };

  return windowSize;
};

export default useWindowSize;
